import { useEffect, useState } from "react";
import { getPrincipalMessage } from "../Service/Api";
import Breadcrumb from "../utlis/Breadcrumb";
import Header from "../Component/Header";
import { Link } from "react-router-dom";

const s3_url = "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com";

function Prinicipal() {
  const [management, setManagement] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const managementData = await getPrincipalMessage();

        const managementData_fiter = managementData.filter(
          (item) => item.category === "Principal",
        );

        setManagement(managementData_fiter);
      } catch (error) {
        console.log("Data Error", error);
        setManagement([]);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      {/* Header */}
      <Header />

      {/* Breadcrumb */}
      <div className="InnerSld">
        <Breadcrumb
          img="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/page-title.jpg"
          title="Principal"
          title2="Message"
          path="Principal Message"
        />
      </div>

      {/* Manager Message Section */}
      <div className="innerbody">
        <div className="container-fluid">
          {management.length > 0 ? (
            management.map((item, index) => (
              <div className="message-div" key={`${item.category}-${index}`}>
                {/* Manager Image */}
                <div className="messageimg">
                  <img
                    id={`manager-image-${index}`}
                    className="img-fluid lazyload"
                    src={
                      item.attachments?.length > 0
                        ? `${s3_url}/${item.attachments[0]}`
                        : "/Images/dummy.jpg"
                    }
                    alt={item.name || "Manager's Image"}
                  />

                  {/* Social Media Overlay */}
                  <div className="social-overlay">
                    <a
                      href="#"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Facebook"
                    >
                      <i className="bi bi-facebook"></i>
                    </a>

                    <a
                      href="#"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Twitter"
                    >
                      <i className="bi bi-twitter-x"></i>
                    </a>

                    <a
                      href="#"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Instagram"
                    >
                      <i className="bi bi-instagram"></i>
                    </a>

                    <a
                      href="#"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="LinkedIn"
                    >
                      <i className="bi bi-linkedin"></i>
                    </a>
                  </div>
                </div>

                {/* Manager Message */}
                <div
                  id={`managermessage-${index}`}
                  dangerouslySetInnerHTML={{
                    __html: item.message || "Coming Soon...",
                  }}
                />

                {/* Manager Name & Designation */}
                <p id={`manager-name-${index}`}>
                  <strong>
                    Warmest Regards,
                    <br />
                    {item.name || "Manager"}
                    <br />
                    {item.designation && `(${item.designation})`}
                  </strong>
                </p>
              </div>
            ))
          ) : (
            <div className="message-div">
              {/* Default Manager Image */}
              <div className="messageimg">
                <img
                  id="manager-image"
                  className="img-fluid lazyload"
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSRB/public/images/dummy.jpg"
                  alt="Manager's Image"
                />

                {/* Social Media Overlay */}
                <div className="social-overlay">
                  <a
                    href="#"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Facebook"
                  >
                    <i className="bi bi-facebook"></i>
                  </a>

                  <a
                    href="#"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Twitter"
                  >
                    <i className="bi bi-twitter-x"></i>
                  </a>

                  <a
                    href="#"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Instagram"
                  >
                    <i className="bi bi-instagram"></i>
                  </a>

                  <a
                    href="#"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="LinkedIn"
                  >
                    <i className="bi bi-linkedin"></i>
                  </a>
                </div>
              </div>

              {/* Default Message */}
              <div id="managermessage">Coming Soon...</div>

              {/* Default Name */}
              <p id="manager-name">
                <strong>
                  Warmest Regards,
                  <br />
                  Rev. Fr. Eulalio Julio Fernandes
                  <br />
                  (Manager)
                </strong>
              </p>
            </div>
          )}
        </div>
      </div>

      <div id="footer" />
    </>
  );
}

export default Prinicipal;
